import { ReactElement } from 'react';

import { AppointmentDetails, AppointmentDetailsQuery } from '@dreryk/egabinet-appointment-frontend-api';
import { AppointmentId } from '@dreryk/egabinet-appointment-published-language-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { commonTranslationKeys } from '@dreryk/react-common';

type VisitCancelNotConfirmedModalLoaderChildrenRenderProps = {
   appointmentDetails: AppointmentDetails;
};

type VisitCancelNotConfirmedModalLoaderProps = {
   appointmentId: number;
   children: (renderProps: VisitCancelNotConfirmedModalLoaderChildrenRenderProps) => ReactElement;
};

export const VisitCancelNotConfirmedModalLoader = (props: VisitCancelNotConfirmedModalLoaderProps): ReactElement => {
   const {
      data: appointmentDetails,
      loading: appointmentDetailsLoading,
      error: appointmentDetailsError,
   } = useCqrsGet<AppointmentDetails>(() => {
      const query = new AppointmentDetailsQuery();
      query.appointmentId = AppointmentId.of(props.appointmentId);
      return query;
   });

   if (appointmentDetailsLoading) {
      return <LoaderSpinner />;
   }

   if (appointmentDetailsError) {
      return (
         <Message
            testId={'error'}
            type={MessageType.NEGATIVE}
            label={commonTranslationKeys.unexpectedErrorHasOccurred}
            displayIndicator
         />
      );
   }

   return props.children({ appointmentDetails: appointmentDetails });
};
